module.exports = __webpack_public_path__ + "img/Pista_19.408fd251.png";